import { render, staticRenderFns } from "./FormProSetting.vue?vue&type=template&id=19d4ea94&scoped=true"
import script from "./FormProSetting.vue?vue&type=script&lang=js"
export * from "./FormProSetting.vue?vue&type=script&lang=js"
import style0 from "./FormProSetting.vue?vue&type=style&index=0&id=19d4ea94&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d4ea94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19d4ea94')) {
      api.createRecord('19d4ea94', component.options)
    } else {
      api.reload('19d4ea94', component.options)
    }
    module.hot.accept("./FormProSetting.vue?vue&type=template&id=19d4ea94&scoped=true", function () {
      api.rerender('19d4ea94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/components/FormProSetting.vue"
export default component.exports